import Images from "config/Images";
import "./SignUpOnboarding.css";

function SignUpOnboarding() {
  return (
    <div className={'sign-up-onboarding'}>
      <div className={'onboarding-element-wrapper'} id={"onboarding-one"}>
        <div className={'onboarding-element'}>
          <img src={Images.onboardingOne} alt={'Onboarding-One'} className={'onboarding-image'}/>
          <p>
            Benevv is the first social cause platform 100% dedicated to promoting social change
          </p>
        </div>
      </div>

      <div className={'onboarding-element-wrapper'} id={"onboarding-two"}>
        <div className={'onboarding-element'}>
          <img src={Images.onboardingTwo} alt={'Onboarding-Two'} className={'onboarding-image'}/>
          <p>
            Benevv connects Brands, Influencers, Non-Profits, and Volunteers to collaborate on making social change
            happen
          </p>
        </div>
      </div>

      <div className={'onboarding-element-wrapper'} id={"onboarding-three"}>
        <div className={'onboarding-element'}>
          <img src={Images.onboardingThree} alt={'Onboarding-Three'} className={'onboarding-image'}/>
          <p>
            Benevv accomplishes this through: User Education and a Call To Action
          </p>
        </div>
      </div>
    </div>
  )
}

export default SignUpOnboarding;
